<template>
  <div class="card mb-3">
    <div class="modal d-block " v-if="addressProblemModal.isOpen" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              ثبت آدرس - {{ addressProblemModal.orderId }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="handleAddressProblemModal('close')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <p style="color: red; text-align: center; font-size: 1rem;">
                {{ addressProblemModal.description }}
              </p>
              <p>آدرس :</p>
              <textarea
                class="form-control"
                v-model="addressProblemModal.currentRecordAddress"
              />
            </div>
            <div
              class="form-group"
              style="display: flex; gap: 5px; margin-top: 10px;"
            >
              <div style="width: 100%; position: relative;" class="form-group">
                <label>استان</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="جستجو در استان‌ها"
                  v-model="provinceSearch"
                  autocomplete="new-provincee"
                  name="search_province_abc123456"
                  @focus="provinceDropdownOpen = true"
                  @input="provinceDropdownOpen = true"
                  @keydown.esc="provinceDropdownOpen = false"
                  @blur="hideProvinceDropdown"
                />
                <div
                  class="list-group position-absolute w-100 border rounded bg-white shadow-sm"
                  v-show="provinceDropdownOpen && filteredProvinces.length"
                  style="z-index: 1050; max-height: 200px; overflow-y: auto;"
                >
                  <button
                    type="button"
                    class="list-group-item list-group-item-action"
                    v-for="province in filteredProvinces"
                    :key="province.id + 'province'"
                    @mousedown.prevent="selectProvince(province)"
                  >
                    {{ province.stateNameFa }}
                  </button>
                </div>
              </div>
              <div style="width: 100%; position: relative;" class="form-group">
                <label>شهر</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="جستجو در شهرها"
                  autocomplete="new-cityy"
                  name="search_city_abc123456"
                  v-model="citySearch"
                  @input="cityDropdownOpen = true"
                  @focus="cityDropdownOpen = true"
                  @keydown.esc="cityDropdownOpen = false"
                  @blur="hideCityDropdown"
                />
                <div
                  class="list-group position-absolute w-100 border rounded bg-white shadow-sm"
                  v-show="cityDropdownOpen && filteredCities.length"
                  style="z-index: 1050; max-height: 200px; overflow-y: auto;"
                >
                  <button
                    type="button"
                    class="list-group-item list-group-item-action"
                    v-for="city in filteredCities"
                    :key="city.id + 'city'"
                    @mousedown.prevent="selectCity(city)"
                  >
                    {{ city.cityNameFa }}
                  </button>
                </div>
              </div>
            </div>
            <div style="width: 50%; position: relative;" class="form-group">
              <label>کد پستی</label>
              <input
                type="number"
                class="form-control"
                v-model="addressProblemModal.postalCode"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="submitAddressProblem()"
            >
              ثبت
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="handleAddressProblemModal('close')"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- <router-link :to="{name: 'bonusCards.blockUnblock'}" class="btn btn-dark">درخواست مسدودی / رفع مسدودی کارت</router-link>
            <router-link v-if="!$store.state.userData.isOrganization && !$store.state.userData.isPishkhan" :to="{name: 'bonusCards.contract'}" class="btn btn-warning mr-2">ایجاد قرارداد</router-link> -->
      <button
        class="btn btn-info ml-2"
        data-toggle="collapse"
        data-target="#advanced"
      >
        جستجو پیشرفته
      </button>
      <!-- <button
        class="btn btn-primary"
        data-toggle="modal"
        data-target="#tracking-code"
      >
        ثبت کد رهگیری پستی
      </button> -->
      <!-- <button
        class="btn btn-outline-primary  mr-2"
        data-toggle="modal"
        data-target="#tracking-code-give"
      >
        دریافت کد رهگیری پستی
      </button> -->
      <button
        class="btn btn-secondary mr-2"
        data-toggle="modal"
        data-target="#update"
        @click="currentAction = 'update'"
      >
        به روزرسانی گروهی
      </button>
      <button
        class="btn btn-outline-secondary mr-2"
        data-toggle="modal"
        data-target="#update"
        @click="currentAction = 'disable'"
      >
        ثبت کارت های امحا شده
      </button>
      <button
        class="btn btn-danger mr-2"
        data-toggle="modal"
        data-target="#update"
        @click="currentAction = 'rejected'"
      >
        ثبت برگشتی های پست
      </button>
      <button class="btn btn-success mr-2" @click="downloadDebitCards">
        دریافت لیست کارت های نقدی
      </button>
      <button class="btn btn-warning mr-2" @click="downloadBonusCards">
        دریافت لیست بن کارت ها
      </button>
      <!-- <button
        class="btn btn-primary mr-2"
        @click="$router.push({ name: 'debitCards.emailReports' })"
      >
        لاگ ایمیل های پست
      </button> -->
      <div class="collapse fade mt-3" id="advanced">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>شماره کارت</label>
              <input
                type="tel"
                class="form-control"
                v-mask="'####-####-####-####'"
                v-model="pan"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>شماره همراه</label>
              <input
                type="tel"
                class="form-control"
                v-mask="'09#########'"
                v-model="mobile"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>نوع کارت</label>
              <select class="form-control" v-model="cardType">
                <option value="">همه</option>
                <option value="jahesh1">JAHESH1</option>
                <option value="Taekwondo">Taekwondo</option>
                <option value="Bama1">Bama1</option>
                <option value="Faraz1">Faraz1</option>
                <option value="Faraz2">Faraz2</option>
                <option value="Faraz3">Faraz3</option>
                <option value="Mizban">Mizban</option>
                <option value="HIWEBWHITE">HIWEBWHITE</option>
                <option value="PURPLE">PURPLE</option>
                <option value="GOLD">GOLD</option>
                <option value="SILVER">SILVER</option>
                <option value="FardaBankPurple">FardaBankPurple</option>
                <option value="FardaBankBlack">FardaBankBlack</option>
                <option value="FardaBankWhite2">FardaBankWhite2</option>
                <option value="FardaBankPink">FardaBankPink</option>
                <option value="FardaBankTiffany">FardaBankTiffany</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>پروژه</label>
              <select class="form-control" v-model="projectId">
                <option value="">همه</option>
                <option
                  v-for="(project, index) in projects"
                  :value="project.id"
                  :key="index"
                  >{{ project.title }} ({{ project.count }})</option
                >
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>طرح کارت</label>
              <select
                class="form-control"
                v-model="designTypeId"
                :disabled="!designTypes.length"
              >
                <option value="">همه</option>
                <option
                  v-for="(designType, index) in designTypes"
                  :value="designType.id"
                  :key="index"
                  >{{ designType.title }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>وضعیت</label>
              <select class="form-control" v-model="statusId">
                <option
                  :value="statusTemplate.value"
                  v-for="(statusTemplate, index) in statusAllTemplate"
                  :key="index"
                  >{{ statusTemplate.title }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>دارای کد رهگیری پستی</label>
              <select class="form-control" v-model="hasPostTrackingCode">
                <option value="1">همه</option>
                <option value="2">بله</option>
                <option value="3">خیر</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <label>نام</label>
            <input type="text" class="form-control" v-model="firstName" />
          </div>
          <div class="col-md-3">
            <label>نام خانوادگی</label>
            <input type="text" class="form-control" v-model="lastName" />
          </div>
          <div class="col-md-3">
            <label>کد ملی</label>
            <input
              type="tel"
              class="form-control"
              v-model="nationalCode"
              maxlength="10"
            />
          </div>
          <div class="col-md-3">
            <label>شناسه سفارش</label>
            <input
              type="tel"
              class="form-control"
              v-model="orderId"
              maxlength="10"
            />
          </div>
          <div class="col-md-3">
            <label>از تاریخ</label>
            <Datepicker
              simple
              auto-submit
              id="from-date"
              locale="fa"
              input-format="YYYY-MM-DD"
              :max="today"
              v-model="fromDate"
              :locale-config="{
                fa: {
                  displayFormat: 'jYYYY/jMM/jDD',
                  lang: { label: 'شمسی' },
                },
              }"
            />
          </div>
          <div class="col-md-3">
            <label>تا تاریخ</label>
            <Datepicker
              simple
              auto-submit
              id="to-date"
              locale="fa"
              input-format="YYYY-MM-DD"
              :max="today"
              v-model="toDate"
              :locale-config="{
                fa: {
                  displayFormat: 'jYYYY/jMM/jDD',
                  lang: { label: 'شمسی' },
                },
              }"
            />
          </div>
        </div>
        <div class="row" style="display: flex; justify-content: end;">
          <div class="col-md-3">
            <button
              class="btn btn-primary btn-block"
              style="margin-top:29px"
              @click="search"
            >
              <i class="si si-magnifier"></i>
              جستجو
            </button>
          </div>
          <div class="col-md-3">
            <button
              class="btn btn-secondary btn-block"
              style="margin-top:29px"
              @click="openLabelsLink"
            >
              چاپ لیبل ها
            </button>
          </div>
        </div>
      </div>

      <hr />
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-1">
          <div class="form-group">
            <label>تعداد</label>
            <select v-model="perPage" class="form-control">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
          </div>
        </div>
        <div class="col-md-8"></div>
        <div class="col-md-3 text-left" style="margin-top:26px">
          تعداد کل ردیف ها : {{ count }} ردیف
        </div>
      </div>
      <div class="table-responsive" v-if="rows.length">
        <table class="table table-hover table-bordered mb-0">
          <thead>
            <tr>
              <th>
                <input type="checkbox" @change="selectAllOrderId" />
              </th>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <!-- <th>جنسیت</th>
                            <th>تاریخ تولد</th> -->
              <th>شماره کارت</th>
              <th>کد رهگیری پستی</th>
              <th>شماره تماس</th>
              <th>وضعیت</th>
              <th>نوع کارت</th>
              <th>طرح کارت</th>
              <th v-if="false">توضیحات</th>
              <th>تاریخ</th>
              <th>ساعت</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td>
                <input
                  type="checkbox"
                  @change="selectOrderId(row.orderId)"
                  :checked="selectedOrderId.includes(row.orderId)"
                  :value="row.orderId"
                  :id="'orderIdSelect-' + row.orderId"
                />
              </td>
              <td>{{ row.orderId }}</td>
              <td>{{ row.fullName }}</td>
              <!-- <td>{{ row.gender || "-" }}</td>
              <td>{{ row.birthdate || "-" }}</td> -->
              <td class="text-center" dir="ltr">{{ row.maskPan }}</td>
              <td class="text-center">
                <div style="margin-bottom: 3px;">
                  <a
                    v-if="row.postTrackingCode"
                    :href="
                      row.postTrackingCode.startsWith('444')
                        ? `https://tms.taroffexpress.com/orderts/barcode/${row.postTrackingCode}`
                        : `https://tracking.post.ir/search.aspx?id=${row.postTrackingCode}`
                    "
                    target="_blank"
                    style="cursor: pointer; font-size: 12px; padding: 2px 6px; color: white; border-radius: 3px;"
                    :class="
                      row.shippingId === 1 ? 'bg-primary' : 'bg-secondary'
                    "
                  >
                    رهگیری {{ row.shippingTitle }}
                  </a>
                </div>
                <div>
                  {{ row.postTrackingCode }}
                </div>
              </td>
              <td class="text-center">{{ row.mobile }}</td>
              <td>
                <div
                  class="text-center"
                  v-html="row.status"
                  @click="
                    row.flowStatusId === 327
                      ? handleAddressProblemModal('open', row)
                      : null
                  "
                  :style="{
                    cursor: row.flowStatusId === 327 ? 'pointer' : 'default',
                  }"
                ></div>
                <div class="text-center mt-1">
                  {{
                    row.updateAt.slice(0, 4) +
                      "/" +
                      row.updateAt.slice(4, 6) +
                      "/" +
                      row.updateAt.slice(6, 8)
                  }}
                  - {{ row.updateAt.split(" ")[1] }}
                </div>
              </td>
              <td>{{ row.type }}</td>
              <td>{{ row.desginTypeTitle || "-" }}</td>
              <td v-if="false">{{ row.description }}</td>
              <td>
                {{
                  row.created_at.slice(0, 4) +
                    "-" +
                    row.created_at.slice(4, 6) +
                    "-" +
                    row.created_at.slice(6, 8)
                }}
              </td>
              <td>{{ row.created_at.split(" ")[1] }}</td>
              <td>
                <button
                  class="btn btn-primary mb-1 ml-2"
                  data-toggle="modal"
                  data-target="#update-city-modal"
                  @click="currentOrderIdForCity = row.orderId"
                  v-if="row.flowStatusId == 82"
                >
                  به روزرسانی شهر
                </button>
                <button
                  class="btn btn-warning ml-2"
                  data-toggle="modal"
                  data-target="#address-modal"
                  @click="showAddress(row.orderId)"
                  v-if="row.flowStatusId == 81"
                >
                  نمایش آدرس
                </button>
                <button
                  class="btn btn-info ml-2"
                  data-toggle="modal"
                  data-target="#postal-modal"
                  @click="currentOrderId = row.orderId"
                  v-if="row.flowStatusId == 82"
                >
                  ثبت اطلاعات پستی
                </button>
                <button
                  class="btn btn-warning ml-2"
                  data-toggle="modal"
                  data-target="#address-modal"
                  @click="address = row.addressString ? row.addressString : '-'"
                  v-if="row.flowStatusId == 82"
                >
                  نمایش آدرس
                </button>
                <button
                  class="btn btn-success ml-2"
                  @click="confirm(row.orderId)"
                  v-if="row.flowStatusId == 83 || row.flowStatusId == 86"
                >
                  تایید / چاپ
                </button>
                <button
                  class="btn btn-danger ml-2"
                  data-toggle="modal"
                  data-target="#reject-modal"
                  @click="currentOrderId = row.orderId"
                  v-if="row.flowStatusId == 83 || row.flowStatusId == 86"
                >
                  عدم تایید
                </button>
                <button
                  class="btn btn-dark"
                  data-toggle="modal"
                  data-target="#bonus-cards-modal"
                  @click="getBonusList(row.orderId)"
                  v-if="row.personType"
                >
                  بن کارت
                </button>
                <span
                  v-if="
                    row.flowStatusId != 81 &&
                      row.flowStatusId != 82 &&
                      row.flowStatusId != 83 &&
                      row.flowStatusId != 86
                  "
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination
          :pages="pages"
          :currentPage="currentPage"
          :prevPageMethod="(e) => currentPage--"
          :nextPageMethod="(e) => currentPage++"
          :changePageMethod="(e, page) => (currentPage = page)"
        />
        <!-- <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                    <div class="col-12" style="overflow-x: auto;">
                        <ul class="pagination pagination-circled">
                            <li class="page-item" v-if="currentPage > 1">
                                <a class="page-link" href="#" v-on:click="currentPage--"><i
                                        class="icon ion-ios-arrow-forward"></i></a>
                            </li>
                            <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages"
                                :key="page">
                                <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                            </li>
                            <li class="page-item" v-if="pages.length != currentPage">
                                <a class="page-link" href="#" v-on:click="currentPage++"><i
                                        class="icon ion-ios-arrow-back"></i></a>
                            </li>
                        </ul>
                    </div>
                </div> -->
      </div>

      <div class="alert alert-info mb-0" v-else>
        <p class="mb-0">داده ای یافت نشد</p>
      </div>
      <div class="modal effect-scale" id="tracking-code" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">ثبت کد رهگیری پستی</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <Loading v-if="showLoading" />
              <div class="form-group">
                <label>انتخاب فایل</label>
                <div class="input-group file-browser">
                  <input
                    type="text"
                    class="form-control border-left-0 browse-file"
                    id="tracking-code-file"
                    placeholder="آپلود فایل"
                    readonly=""
                  />
                  <label class="input-group-btn mb-0">
                    <span class="btn btn-primary">
                      انتخاب کنید
                      <input
                        type="file"
                        id="tracking-file-input"
                        style="display: none;"
                        accept=".xlsx"
                        @input="setFile"
                      />
                    </span>
                  </label>
                </div>
              </div>
              <p>
                <button class="btn btn-link mb-3" @click="downloadSampleFile">
                  دریافت فایل نمونه
                </button>
              </p>
              <button class="btn btn-success" @click="updateTrackingCodeData">
                ثبت اطلاعات
              </button>
              <button
                class="btn btn-info mr-2"
                v-if="fileResult != ''"
                @click="downloadResultFile"
              >
                دریافت فایل نتیجه
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal effect-scale"
        id="tracking-code-give"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">دریافت کد رهگیری پستی</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <Loading v-if="showLoading" />

              <div class="form-group">
                <label>انتخاب قالب</label>
                <select
                  class="form-control"
                  v-model="callTemplateId"
                  @change="showCallParametersTemplate"
                >
                  <option
                    :value="callTemplate.templateId"
                    v-for="(callTemplate, index) in postalCodesCallTemplate"
                    :key="index"
                    >{{ callTemplate.templateTitle }}</option
                  >
                </select>
              </div>

              <table
                class="table table-hover table-bordered mb-0"
                v-if="templateparameters.length > 0"
              >
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>مقدار</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in templateparameters" :key="index">
                    <td>{{ row.title }}</td>

                    <td v-if="row.valueType === 'select'">
                      <select
                        class="form-control"
                        v-model="callParameterSelectedId[row.parameterName]"
                      >
                        <option
                          :value="selectOption.value"
                          v-for="(selectOption, index) in row.selectableOptions"
                          :key="index"
                        >
                          {{ selectOption.title }}
                        </option>
                      </select>
                    </td>

                    <td v-if="row.valueType === 'label'">
                      <input
                        type="text"
                        class="form-control ltr-input"
                        style="text-align: right !important;"
                        :placeholder="row.selectableOptions[0].title"
                        v-value="row.selectableOptions[0].title"
                        v-model="callParameterSelectedId[row.parameterName]"
                        readonly=""
                      />
                    </td>

                    <td v-if="row.valueType === 'input'">
                      <input
                        type="number"
                        class="form-control ltr-input"
                        v-model="callParameterSelectedId[row.parameterName]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                aria-label="بستن"
                data-dismiss="modal"
                v-if="templateparameters.length > 0"
                class="btn btn-success mt-4 mx-auto text-center"
                @click="enqueueForPostTrackingCode"
              >
                درخواست کد رهگیری پستی
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="update" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">به روزرسانی گروهی</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <Loading v-if="showLoading" />
              <div class="form-group">
                <label>انتخاب فایل</label>
                <div class="input-group file-browser">
                  <input
                    type="text"
                    class="form-control border-left-0 browse-file"
                    id="update-file"
                    placeholder="آپلود فایل"
                    readonly=""
                  />
                  <label class="input-group-btn mb-0">
                    <span class="btn btn-primary">
                      انتخاب کنید
                      <input
                        type="file"
                        id="update-input"
                        style="display: none;"
                        accept=".xlsx"
                        @input="setChangeStatusFile"
                      />
                    </span>
                  </label>
                </div>
              </div>
              <p>
                <button
                  class="btn btn-link mb-3"
                  @click="downloadChangeStatusSampleFile"
                >
                  دریافت فایل نمونه
                </button>
              </p>
              <button
                class="btn btn-success"
                v-if="currentAction == 'update'"
                @click="updateGroupData"
              >
                ثبت اطلاعات
              </button>
              <button
                class="btn btn-success"
                v-else-if="currentAction == 'disable'"
                @click="updateDisableData"
              >
                ثبت اطلاعات
              </button>
              <button
                class="btn btn-success"
                v-else
                @click="updateRejectGroupData"
              >
                ثبت اطلاعات
              </button>
              <button
                class="btn btn-info mr-2"
                v-if="changeStatusFileResult != ''"
                @click="downloadChangeStatusResultFile"
              >
                دریافت فایل نتیجه
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="address-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">آدرس</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{ address }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="reject-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">عدم تایید کارت</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>توضیحات</label>
                <textarea
                  v-model="description"
                  class="form-control"
                  rows="3"
                ></textarea>
              </div>
              <button
                class="btn btn-success"
                data-dismiss="modal"
                @click="reject"
              >
                ثبت و عدم تایید کارت
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="postal-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">ثبت اطلاعات پستی</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>کد رهگیری پستی</label>
                <input
                  type="tel"
                  class="form-control ltr-input"
                  v-model="postalTrackingCode"
                  maxlength="24"
                />
              </div>
              <button
                class="btn btn-success"
                data-dismiss="modal"
                @click="submitPostalData"
              >
                ثبت کد رهگیری
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="bonus-cards-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">سفارشات بن کارت</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <Loading v-if="showLoading" />
              <table class="table table-bordered mb-0">
                <thead>
                  <th>ردیف</th>
                  <th>سفارش</th>
                  <th>عملیات</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in bonusList" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>سفارش شماره {{ item }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'bonusCards.single',
                          params: { id: item },
                        }"
                        data-dismiss="modal"
                        >مشاهده سفارش</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal effect-scale" id="update-city-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-content-demo">
            <div class="modal-header">
              <h6 class="modal-title">به روزرسانی شهر</h6>
              <button
                aria-label="بستن"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <Loading v-if="showLoading" />
              <div class="form-group">
                <label>استان</label>
                <select v-model="provinceId" class="form-control">
                  <option
                    v-for="(province, index) in provinces"
                    :value="province.provinceId"
                    :key="index"
                    >{{ province.title }}</option
                  >
                </select>
              </div>
              <div class="form-group">
                <label>شهر</label>
                <select
                  v-model="cityId"
                  class="form-control"
                  :disabled="!provinceId || !cities.length"
                >
                  <option
                    v-for="(city, index) in cities"
                    :value="city.cityId"
                    :key="index"
                    >{{ city.title }}</option
                  >
                </select>
              </div>
              <button
                class="btn btn-success mt-3 btn-block"
                @click="updateOrderCity"
                data-dismiss="modal"
              >
                ذخیره تغییرات
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../Partials/Pagination";
import moment from "moment-jalaali";
export default {
  name: "Index",
  components: { Pagination },
  data() {
    return {
      // columns: [
      //     {
      //         title: 'شناسه',
      //         field: 'orderId'
      //     },
      //     {
      //         title: 'نام',
      //         field: 'fullName'
      //     },
      //     {
      //         title: 'سازمان',
      //         field: 'customerName'
      //     },
      //     {
      //         title: 'وضعیت سفارش',
      //         field: 'statusTitle'
      //     },
      //     {
      //         title: 'نوع سفارش',
      //         field: 'orderType'
      //     },
      //     {
      //         title: 'مبلغ',
      //         field: 'amount'
      //     },
      //     {
      //         title: 'تاریخ',
      //         field: 'createdAt'
      //     },
      //     {
      //         title: 'ساعت',
      //         field: 'createdAtTime'
      //     }
      // ],
      rows: [],
      currentOrderId: 0,
      description: "",
      postalTrackingCode: "",
      callTemplateId: 0,
      statusId: "",
      callParameterId: 0,
      callParameterSelectedId: {},
      address: "",
      showLoading: false,
      bonusList: [],
      updateFileSample: "",
      file: "",
      fileResult: "",
      changeStatusFileSample: "",
      changeStatusFile: "",
      changeStatusFileResult: "",
      pages: [],
      currentPage: 1,
      cardType: "",
      status: 1,
      hasPostTrackingCode: 1,
      currentAction: "update",
      perPage: 100,
      count: 0,
      pan: "",
      mobile: "",
      orderId: "",
      firstName: "",
      lastName: "",
      nationalCode: "",
      postalCodesCallTemplate: [],
      statusAllTemplate: [],
      flowStatusAllTemplate: [],
      templateparameters: [],
      templateParametersSelected: [],
      flowStatus: [],
      selectedOrderId: [],
      provinces: [],
      provinceId: 0,
      today: moment().format("jYYYY-jMM-jDD"),
      fromDate: "",
      toDate: "",
      cities: [],
      cityId: 0,
      currentOrderIdForCity: 0,
      projects: [],
      projectId: 0,
      designTypes: [],
      designTypeId: 0,

      addressProblemModal: {
        isOpen: false,
        currentRecordAddress: "",
        cityId: "",
        provinceId: "",
        orderId: "",
        provinces: [],
        cities: [],
        postalCode: 0,
        description: "",
      },
      provinceSearch: "",
      provinceDropdownOpen: false,
      citySearch: "",
      cityDropdownOpen: false,
      // dataTableKey: 0
    };
  },
  watch: {
    currentOrderId(value) {
      this.bonusList = [];
      if (value) {
        let order = rows.find((row) => row.orderId == value);
        this.bonusList = order ? order.bonusList : [];
      }
    },
    currentPage(value) {
      if (value) this.getData();
    },
    perPage(value) {
      if (value) this.getData();
    },
    provinceId(value) {
      if (value) this.getCities();
    },
    projectId(value) {
      if (value) this.getProjectTypes();
    },
    "addressProblemModal.provinceId"(value) {
      if (value) this.getCitiesForAddressProblem();
    },
  },
  computed: {
    filteredProvinces() {
      const term = this.provinceSearch.toLowerCase();
      return this.addressProblemModal.provinces.filter((p) =>
        p.stateNameFa.toLowerCase().includes(term),
      );
    },
    filteredCities() {
      const term = this.citySearch.toLowerCase();
      return this.addressProblemModal.cities.filter((c) =>
        c.cityNameFa.toLowerCase().includes(term),
      );
    },
  },
  methods: {
    getData() {
      this.showLoading = true;

      const statuses = this.statusId
        ? this.statusId.split(",").map((item) => parseInt(item))
        : [81, 82, 83, 84, 85, 86, 327, 348, 349, 389, 394, 434, 162, 416];

      const postedData = {
        mobile: this.mobile,
        statuses,
        pan: this.pan.replace(/-/g, ""),
        cType: this.cardType,
        orderId: this.orderId || 0,
        take: this.currentPage,
        perPage: this.perPage,
        firstName: this.firstName,
        lastName: this.lastName,
        nationalCode: this.nationalCode,
        hasPostTrackingCode:
          this.hasPostTrackingCode == 1
            ? null
            : this.hasPostTrackingCode == 2
            ? true
            : false,
      };
      if (this.fromDate) {
        postedData.fromDate = this.fromDate;
      } else {
        postedData.fromDate = moment()
          .subtract(21, "days")
          .format("jYYYY/jMM/jDD");
      }
      if (this.toDate) {
        postedData.toDate = this.toDate;
      } else {
        postedData.toDate = moment().format("jYYYY/jMM/jDD");
      }
      if (this.designTypeId) postedData.designTypeId = this.designTypeId;
      if (this.projectId) postedData.projectId = this.projectId;
      this.$api
        .post("CardIssue/Cards/Search", postedData)
        .then(({ data }) => {
          if (data.status) {
            let result = [];
            let status;
            data.result.list.map((item) => {
              const selectedFlowState = this.flowStatusAllTemplate.find(
                (it) => it.value == item.flowStatusId,
              );

              status = `<span 
                        class="${
                          [45, 81, 82, 86, 349, 394, 434].includes(
                            parseInt(selectedFlowState.value),
                          )
                            ? "badge badge-success"
                            : [84, 327, 348, 389].includes(
                                parseInt(selectedFlowState.value),
                              )
                            ? "badge badge-danger"
                            : [417, 416, 85, 83].includes(
                                parseInt(selectedFlowState.value),
                              )
                            ? "badge badge-primary"
                            : ""
                        }"> ${selectedFlowState.title} </span>`;

              result.push({
                ...item,
                status,
              });
            });
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
            // this.rows.operations = ['bonusCards',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
            // this.dataTableKey += 1;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
      this.getLookups();
    },
    getLookups() {
      this.$api
        .post("CardIssue/Cards/UploadTrackingCodeSample", { file: "" })
        .then(({ data }) => {
          this.updateFileSample = data.result;
        });
      this.$api
        .post("CardIssue/Cards/ChangeStatusBalkSample", { file: "" })
        .then(({ data }) => {
          this.changeStatusFileSample = data.result;
        });
      this.$api
        .post("Lookup/ExternalApi/GetApiCallTemplates", { apiId: 1 })
        .then(({ data }) => {
          this.postalCodesCallTemplate = data.result.templates;
        });
      this.$api
        .post("Lookup/GetLookupList", { lookupName: "CardStatusSearch" })
        .then(({ data }) => {
          this.statusAllTemplate = data.result.items;
        });

      this.$api
        .post("Lookup/GetLookupList", { lookupName: "CardStatus" })
        .then(({ data }) => {
          this.flowStatusAllTemplate = data.result.items;
        });
      this.$api.get("Project/GetAllProject").then(({ data }) => {
        if (data.status) this.projects = data.result;
      });
    },
    getProjectTypes() {
      const projectId = this.projectId;
      this.$api
        .get("Project/GetDesignTypeByProjectId?ProjectId=" + projectId)
        .then(({ data }) => {
          if (data.status) this.designTypes = data.result;
        });
    },
    getCities() {
      this.$api.get(`Shipping/Cities/${this.provinceId}`).then(({ data }) => {
        this.cities = data.result;
      });
    },
    selectOrderId(id) {
      if (this.selectedOrderId.includes(id))
        this.selectedOrderId.splice(this.selectedOrderId.indexOf(id), 1);
      else this.selectedOrderId.push(id);
    },
    selectAllOrderId(e) {
      if (e.target.checked) {
        let ids = [];
        this.rows.map((row) => ids.push(row.orderId));
        this.selectedOrderId.push(...ids);
      } else this.selectedOrderId = [];
    },
    search() {
      if (!this.fromDate || !this.toDate) {
        this.$swal({
          title: "",
          icon: "warning",
          text: "لطفاً بازه زمانی (از تاریخ و تا تاریخ) را وارد کنید.",
        });

        return;
      }

      const from = moment(this.fromDate, "YYYY-MM-DD");
      const to = moment(this.toDate, "YYYY-MM-DD");
      const diffDays = to.diff(from, "days");

      if (diffDays < 0) {
        this.$swal({
          title: "",
          icon: "warning",
          text: "تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد.",
        });
        return;
      }

      if (diffDays > 180) {
        this.$swal({
          title: "",
          icon: "warning",
          text: "بازه زمانی انتخابی نباید بیشتر از ۱۸۰ روز باشد.",
        });
        return;
      }
      this.currentPage = 1;
      this.getData();
    },
    downloadDebitCards() {
      this.showLoading = true;

      const statuses = this.statusId
        ? this.statusId.split(",").map((item) => parseInt(item))
        : [81, 82, 83, 84, 85, 86, 327, 348, 349, 389, 394, 434, 162, 416];
      const postedData = {
        mobile: this.mobile,
        statuses,
        pan: this.pan.replace(/-/g, ""),
        cType: this.cardType,
        orderId: this.orderId || 0,
        take: 0,
        perPage: this.perPage,
        sheetDebit: true,
        sheetBonus: false,
        firstName: this.firstName,
        lastName: this.lastName,
        nationalCode: this.nationalCode,
        hasPostTrackingCode:
          this.hasPostTrackingCode == 1
            ? null
            : this.hasPostTrackingCode == 2
            ? true
            : false,
      };
      if (this.fromDate) postedData.fromDate = this.fromDate;
      if (this.toDate) postedData.toDate = this.toDate;
      if (this.designTypeId) postedData.designTypeId = this.designTypeId;
      if (this.projectId) postedData.projectId = this.projectId;
      this.$api
        .post("CardIssue/Cards/Search", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.debitFile,
            );
            let fileName = data.result.debitFile;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    downloadBonusCards() {
      this.showLoading = true;

      const statuses = this.statusId
        ? this.statusId.split(",").map((item) => parseInt(item))
        : [81, 82, 83, 84, 85, 86, 327, 348, 349, 389, 394, 434, 162, 416];
      const postedData = {
        mobile: this.mobile,
        statuses,
        pan: this.pan.replace(/-/g, ""),
        cType: this.cardType,
        orderId: this.orderId || 0,
        take: 0,
        perPage: this.perPage,
        sheetDebit: false,
        sheetBonus: true,
        firstName: this.firstName,
        lastName: this.lastName,
        nationalCode: this.nationalCode,
        hasPostTrackingCode:
          this.hasPostTrackingCode == 1
            ? null
            : this.hasPostTrackingCode == 2
            ? true
            : false,
      };
      if (this.fromDate) postedData.fromDate = this.fromDate;
      if (this.toDate) postedData.toDate = this.toDate;
      if (this.designTypeId) postedData.designTypeId = this.designTypeId;
      if (this.projectId) postedData.projectId = this.projectId;
      this.$api
        .post("CardIssue/Cards/Search", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.debitFile,
            );
            let fileName = data.result.debitFile;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    getBonusList(orderId) {
      this.showLoading = true;
      this.$api
        .post("CardIssue/Cards/Child", { orderId })
        .then(({ data }) => {
          if (data.status) this.bonusList = data.result.orderId;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    getBonusCards() {
      this.showLoading = true;
      this.$api.post().then(({ data }) => {});
    },
    showAddress(orderId) {
      let order = this.rows.filter((row) => row.orderId == orderId)[0];
      this.address = order.addressString;
    },
    submitPostalData() {
      this.showLoading = true;
      const postedData = {
        orderId: this.currentOrderId,
        flowStatusId: 81,
        postalTrackingCode: this.postalTrackingCode.toString(),
      };
      this.$api
        .post("CardIssue/UpdateStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "کارت مورد نظر با موفقیت تایید شد",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
          this.postalTrackingCode = "";
        });
    },
    enqueueForPostTrackingCode() {
      this.showLoading = true;

      this.templateparameters
        .filter((item) => item.valueType === "label")
        .forEach((item) => {
          this.callParameterSelectedId[item.parameterName] =
            item.selectableOptions[0].value;
        });

      this.templateparameters
        .filter((item) => item.dataType === "number")
        .forEach((item) => {
          this.callParameterSelectedId[item.parameterName] = parseInt(
            this.callParameterSelectedId[item.parameterName],
          );
        });

      const body = {
        orderIds: this.selectedOrderId,
        postOptions: this.callParameterSelectedId,
        templateId: this.callTemplateId,
      };

      this.$api
        .post("Orders/PostService/EnqueueForPostTrackingCode", body)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "عملیات مورد نظر با موفقیت تایید شد",
            });
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.filename,
            );
            let fileName = data.result.debitFile;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);

            this.selectedOrderId.map((item) => {
              document.getElementById("orderIdSelect-" + item).checked = false;
            });

            this.selectedOrderId = [];
            this.templateparameters = [];
            this.callTemplateId = 0;

            this.getData();
          }
        })
        .catch(() => {
          this.$swal({
            title: "ناموفق",
            icon: "danger",
            text: "عملیات مورد نظر متاسفانه انجام نشد",
          });

          this.selectedOrderId.map((item) => {
            document.getElementById("orderIdSelect-" + item).checked = false;
          });

          this.templateparameters = [];
          this.callTemplateId = 0;

          this.getData();
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    confirm(orderId) {
      this.showLoading = true;
      const postedData = {
        orderId,
        flowStatusId: 82,
      };
      this.$api
        .post("CardIssue/UpdateStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "کارت مورد نظر با موفقیت تایید شد",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    reject() {
      this.showLoading = true;
      const postedData = {
        orderId: this.currentOrderId,
        flowStatusId: 84,
        description: this.description,
      };
      this.$api
        .post("CardIssue/UpdateStatus", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "کارت مورد نظر با موفقیت رد شد",
            });
            this.getData();
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async setFile(e) {
      const file = e.target.files[0];
      const finalFile = await this.toBase64(file);
      this.file = finalFile;
      document
        .getElementById("tracking-code-file")
        .setAttribute("placeholder", file.name);
    },
    async setChangeStatusFile(e) {
      const file = e.target.files[0];
      const finalFile = await this.toBase64(file);
      console.log(finalFile);
      this.changeStatusFile = finalFile;
      document
        .getElementById("update-file")
        .setAttribute("placeholder", file.name);
    },
    downloadSampleFile() {
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
          this.updateFileSample,
      );
      let fileName = this.updateFileSample;
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    downloadChangeStatusSampleFile() {
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
          this.changeStatusFileSample,
      );
      let fileName = this.changeStatusFileSample;
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    showCallParametersTemplate() {
      this.showLoading = true;
      const postedData = {
        templateId: this.callTemplateId,
      };
      this.$api
        .post("Lookup/ExternalApi/GetApiCallParameters", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.templateparameters = data.result.parameters;
            data.result.parameters
              .filter((item) => item.valueType === "label")
              .forEach((item) => {
                this.callParameterSelectedId[item.parameterName] =
                  item.selectableOptions[0].title;
              });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    showStatusParametersTemplate() {
      this.showLoading = true;
      const postedData = {
        lookupName: "CardStatusSearch",
      };
      this.$api
        .post("Lookup/GetLookupList", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.statusAllTemplate = data.result.items;
            data.result.items.forEach((item) => {
              this.callParameterSelectedId[item.value] =
                item.selectableOptions[0].title;
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    updateTrackingCodeData() {
      this.showLoading = true;
      const postedData = {
        file: this.file,
      };
      this.$api
        .post("CardIssue/Cards/UploadTrackingCode", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              title: "تبریک",
              icon: "success",
              text:
                "جهت مشاهده نتیجه ، بر روی دکمه دریافت فایل نتیجه کلیک کنید",
              confirmButtonText: "متوجه شدم",
            });
          this.fileResult = data.result.fileString;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    updateGroupData() {
      this.showLoading = true;
      const postedData = {
        file: this.changeStatusFile,
      };
      this.$api
        .post("CardIssue/Cards/ChangeStatusBalk", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              title: "تبریک",
              icon: "success",
              text:
                "جهت مشاهده نتیجه ، بر روی دکمه دریافت فایل نتیجه کلیک کنید",
              confirmButtonText: "متوجه شدم",
            });
          this.changeStatusFileResult = data.result.fileName;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    updateDisableData() {
      this.showLoading = true;
      const postedData = {
        file: this.changeStatusFile,
      };
      this.$api
        .post("CardIssue/Cards/UpdateDisableCards", postedData)
        .then(({ data }) => {
          if (data.status)
            this.$swal({
              title: "تبریک",
              icon: "success",
              text:
                "جهت مشاهده نتیجه ، بر روی دکمه دریافت فایل نتیجه کلیک کنید",
              confirmButtonText: "متوجه شدم",
            });
          this.changeStatusFileResult = data.result;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    updateRejectGroupData() {
      debugger;
      this.showLoading = true;
      const postedData = {
        file: this.changeStatusFile,
      };
      this.$api
        .post("CardIssue/Cards/ChangeStatus/Post", postedData)
        .then(({ data }) => {
          debugger;
          if (data.status)
            this.$swal({
              title: "تبریک",
              icon: "success",
              text:
                "جهت مشاهده نتیجه ، بر روی دکمه دریافت فایل نتیجه کلیک کنید",
              confirmButtonText: "متوجه شدم",
            });
          this.changeStatusFileResult = data.result;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    downloadResultFile() {
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
          this.fileResult,
      );
      let fileName = this.fileResult;
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    downloadChangeStatusResultFile() {
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
          this.changeStatusFileResult,
      );
      let fileName = this.changeStatusFileResult;
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    updateOrderCity() {
      this.showLoading = true;
      const postedData = {
        cityId: this.cityId,
        orderId: currentOrderIdForCity,
      };
      this.$api
        .post("Order/EditCity", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "سفارش مورد نظر با موفقیت به روزرسانی شد",
              confirmButtonText: "متوجه شدم",
            });
            this.provinceId = 0;
            this.cityId = 0;
            this.currentOrderIdForCity = 0;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    openLabelsLink() {
      const statuses = this.statusId
        ? this.statusId.split(",").map((item) => parseInt(item))
        : [81, 82, 83, 84, 85, 86, 327, 348, 349, 389, 394, 434, 162, 416];
      const postedData = {
        mobile: this.mobile,
        statuses,
        pan: this.pan.replace(/-/g, ""),
        cType: this.cardType,
        orderId: this.orderId || 0,
        take: this.currentPage,
        perPage: this.perPage,
        firstName: this.firstName,
        lastName: this.lastName,
        nationalCode: this.nationalCode,
        hasPostTrackingCode:
          this.hasPostTrackingCode == 1
            ? null
            : this.hasPostTrackingCode == 2
            ? true
            : false,
      };
      if (this.fromDate) postedData.fromDate = this.fromDate;
      if (this.toDate) postedData.toDate = this.toDate;
      if (this.designTypeId) postedData.designTypeId = this.designTypeId;
      if (this.projectId) postedData.projectId = this.projectId;
      localStorage.setItem("filter", JSON.stringify(postedData));
      setTimeout(() => {
        const routeData = this.$router.resolve({ name: "debitCards.label" });
        window.open(routeData.href, "_blank");
      }, 500);
    },
    handleAddressProblemModal(command, record = null) {
      const rawModalData = {
        isOpen: false,
        currentRecordAddress: "",
        city: "",
        state: "",
        orderId: "",
        cityId: "",
        provinceId: "",
        provinces: this.addressProblemModal.provinces,
        cities: [],
      };
      console.log(record);

      if (command === "close") {
        this.addressProblemModal = rawModalData;
        this.citySearch = "";
        this.provinceSearch = "";
      }
      if (command === "open" && record) {
        this.$api.get("Shipping/Post/Provinces").then(({ data }) => {
          this.addressProblemModal.provinces = data.result;
        });
        console.log(record);

        this.addressProblemModal.isOpen = true;
        if (record.description)
          this.addressProblemModal.description = record.description;
        this.addressProblemModal.orderId = record.orderId;
        this.addressProblemModal.postalCode = record.postalCode;
        this.addressProblemModal.currentRecordAddress = record.addressString.replaceAll(
          ",",
          " , ",
        );
      }
    },
    submitAddressProblem() {
      const body = {
        orderId: this.addressProblemModal.orderId,
        cityId: this.addressProblemModal.cityId,
        address: this.addressProblemModal.currentRecordAddress,
        zipCode: this.addressProblemModal.postalCode,
      };
      this.$api
        .post("Orders/UpdateCityId", { ...body })
        .then(({ data }) => {
          if (data.status && data.result) {
            this.handleAddressProblemModal("close");
            // this.getData();
            const rowIndex = this.rows.findIndex((r) => {
              return r.orderId === body.orderId;
            });
            if (rowIndex !== -1) {
              const updatedRows = this.rows;
              updatedRows[rowIndex].flowStatusId = 86;
              updatedRows[
                rowIndex
              ].status = `<span class="badge badge-success">بروز رسانی شده</span>`;

              this.rows = updatedRows;
              // this.$set(this.rows[rowIndex], "flowStatusId", 86);
            }

            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "شهر با موفقیت ثبت شد",
            });
          } else {
            this.$swal({
              title: "خطا",
              icon: "error",
              text: "درخواست ناموفق",
            });
          }
        })
        .catch((e) => {
          console.log("error: ", e);
          this.$swal({
            title: "خطا",
            icon: "error",
            text: "مشکلی پیش آمده ست",
          });
        });
    },
    getCitiesForAddressProblem() {
      this.$api
        .post("Shipping/Post/Cities", {
          provinceId: this.addressProblemModal.provinceId,
        })
        .then(({ data }) => {
          this.addressProblemModal.cities = data.result;
        });
    },
    selectProvince(province) {
      this.addressProblemModal.provinceId = province.id;
      this.provinceSearch = province.stateNameFa;
      this.provinceDropdownOpen = false;

      this.citySearch = "";
      this.addressProblemModal.cityId = "";
    },

    selectCity(city) {
      this.addressProblemModal.cityId = city.id;
      this.citySearch = city.cityNameFa;
      this.cityDropdownOpen = false;
    },

    hideProvinceDropdown() {
      setTimeout(() => {
        this.provinceDropdownOpen = false;
      }, 150);
    },

    hideCityDropdown() {
      setTimeout(() => {
        this.cityDropdownOpen = false;
      }, 151);
    },
  },
  created() {
    this.getLookups();
    this.$api.get("Shipping/Provinces").then(({ data }) => {
      this.provinces = data.result;
    });
  },
};
</script>
